import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { fetchActivityImage } from '../api/api';

const AuthenticatedPDF = ({ url, title = "PDF Viewer", width = "100%", height = "600px", ...props }) => {
    const [pdfSrc, setPdfSrc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;

        const fetchPDF = async () => {
            try {
                setLoading(true);
                setError(false);
                console.log("Fetching PDF for URL:", url);
                const blob = await fetchActivityImage(url);

                if (active) {
                    console.log("Setting PDF source");
                    // Ensure the blob is treated as a PDF
                    const pdfBlob = new Blob([blob], { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    setPdfSrc(pdfUrl);
                }
            } catch (err) {
                console.error("Error fetching PDF:", err);
                if (active) {
                    setError(true);
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        if (url) {
            fetchPDF();
        } else {
            setLoading(false);
            setError(true);
        }

        return () => {
            active = false;
            if (pdfSrc) {
                URL.revokeObjectURL(pdfSrc);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: height, backgroundColor: '#f8f9fa' }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (error || !pdfSrc) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: height, backgroundColor: '#f8f9fa', color: '#6c757d' }}>
                <small>PDF não disponível</small>
            </div>
        );
    }

    return (
        <object
            data={pdfSrc}
            type="application/pdf"
            width={width}
            height={height}
            style={props.style}
            {...props}
        >
            <embed
                src={pdfSrc}
                type="application/pdf"
                width={width}
                height={height}
            />
            <p className="text-center mt-3">
                Este navegador não suporta a visualização de PDFs.
                <br />
                <a href={pdfSrc} download={`document.pdf`} className="btn btn-primary mt-2">
                    Baixar PDF
                </a>
            </p>
        </object>
    );
};

export default AuthenticatedPDF;

